import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2),
    },
    mainContainer: {
        paddingTop: theme.spacing(5)
    }
}));

export default useStyles;